<div class="filter-item" [formGroup]="filtersForm">
  <div class="d-flex align-items-center">
    <span class="input-label">{{ filterItem.caption }}</span>

    <filter-item-config
      *ngIf="filterItem.configQueryOperators"
      [defaultOperator]="filterItem.queryOperator"
      [operators]="filterItem.configQueryOperators"
      (operatorSelect)="onOperatorSelect($event)"
      class="ml-auto"
    ></filter-item-config>
  </div>

  <input
    class="input"
    [type]="filterItem.type"
    [formControlName]="filterItem.name"
    [id]="filterItem.name"
    [placeholder]="filterItem.placeholder"
    [class.invalid]="
      filtersForm.get(filterItem.name)?.invalid &&
      filtersForm.get(filterItem.name)?.touched
    "
  />

  <div
    class="invalid-feedback text-left"
    *ngIf="
      filtersForm.get(filterItem.name)?.invalid &&
      filtersForm.get(filterItem.name)?.touched
    "
  >
    <span *ngIf="filtersForm.get(filterItem.name)?.errors?.required"
      >This field is required</span
    >
    <span *ngIf="filtersForm.get(filterItem.name)?.errors?.minlength"
      >Min length:
      {{
        filtersForm.get(filterItem.name)?.errors?.minlength.requiredLength
      }}</span
    >
  </div>
</div>
